/**
 * SESSION.TS
 * Allow to pass session in every format function for custom selectors
 */
import { Session } from "@/redux/_session.types"

export const sessionSelector = (state): Session => state._session
